module.exports = "https://cdn.hellotech.com/client-assets/blueblob_e2e5892b23e15f4a8611dbfb65ef5335.svg";